<div class="enquiries_sec">
  <!-- <div class="my_order_head">
    <form action="" class="form-section my_order_form">
      <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
        fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
        <div fxLayout="column" fxFlex.xl="60" fxFlex.lg="60" fxFlex.md="60" fxFlex.sm="60" fxFlex.xs="100" fxFlexFill>
          <div class="filter_flex">
            <div class="custom-form-group">
              <div class="custom-form-control">
                <mat-form-field appearance="outline">
                  <mat-select placeholder="All Supplier">
                    <mat-option disabled=""> Select Supplier </mat-option>
                    <mat-option [value]="'selectValue'">One Supplier</mat-option>
                    <mat-option [value]="'selectValue'">Two Supplier</mat-option>
                    <mat-option [value]="'selectValue'">Three Supplier</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="custom-form-group">
              <div class="custom-form-control">
                <mat-form-field appearance="outline">
                  <mat-select placeholder="All Supplier">
                    <mat-option disabled=""> Order Status </mat-option>
                    <mat-option [value]="'selectValue'">Pending</mat-option>
                    <mat-option [value]="'selectValue'">Out for Delivery</mat-option>
                    <mat-option [value]="'selectValue'">Cancel</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
        <div fxLayout="column" fxFlex.xl="10" fxFlex.lg="10" fxFlex.md="10" fxFlex.sm="10" fxFlex.xs="100" fxFlexFill>
        </div>
         <div fxLayout="column" fxFlex.xl="30" fxFlex.lg="30" fxFlex.md="30" fxFlex.sm="30" fxFlex.xs="100" fxFlexFill>
          <div class="date_group">
            <mat-form-field appearance="fill">
              <mat-label>Enter a date range</mat-label>
              <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
                <input matStartDate formControlName="start" placeholder="Start date" (click)="picker.open()">
                <input matEndDate formControlName="end" placeholder="End date" (click)="picker.open()">
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
            <span>
              <img src="../../../../../assets/images/icons/left.svg" alt="">
            </span>
            <a>May 11 - Aug 30, 2019</a>
            <span>
              <img src="../../../../../assets/images/icons/right.svg" alt="">
            </span>
          </div>
        </div>
      </div>
    </form>
  </div> -->
  <!-- tables-section -->
  <section class="table_section">
    <!-- TABS -->
    <!-- table-data -->
    <!-- TABLE-LISTING -->
    <div class="custom-sticky-table" fxLayout="column" fxLayoutAlign="start stretch">
      <perfect-scrollbar>
        <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)" multiTemplateDataRows>
          <!-- Checkbox Column -->
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
              <mat-checkbox (change)="$event ? masterToggle() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
              </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row">
              <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
              </mat-checkbox>
            </td>
          </ng-container>
          <!-- Position Column -->
          <ng-container matColumnDef="sNo">
            <th mat-header-cell *matHeaderCellDef> S.No </th>
            <td mat-cell *matCellDef="let element;let i=dataIndex" data-label="S.No"> {{offset.value + i+1}} </td>
          </ng-container>
          <!-- date -->
          <ng-container matColumnDef="created_at">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Enquiry Date </th>
            <td mat-cell *matCellDef="let element" data-label="Enquiry Date">
              <span> {{element.created_at | date: 'dd-MM-yyyy hh:mm:ss'}}</span>
            </td>
          </ng-container>
          <!-- Product Image Column -->
          <ng-container matColumnDef="image">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Product Image </th>
            <td mat-cell *matCellDef="let element" data-label="Product Image">
              <img [src]="element?.supply_variant?.image?.url"
              onerror='this.onerror=null;this.src="../../../../../assets/images/empty-imgs/alt_img.jpg";'
              alt="" class="table-img product-img">
            </td>
          </ng-container>
          <!-- Product Name Column -->
          <ng-container matColumnDef="supply_id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Product Name </th>
            <td mat-cell *matCellDef="let element" data-label="Product Name">
              <span class="table_name_flex">{{element?.supply?.name}}</span></td>
          </ng-container>
          <!-- User Name -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>User Name </th>
            <td mat-cell *matCellDef="let element" data-label="Name">
              <span>
                {{element.dental_supplier?.name}}
                {{element.dental_practice?.name}}
                {{element.dental_professional?.name}}
              </span>
            </td>
          </ng-container>
          <!-- Email -->
          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
            <td mat-cell *matCellDef="let element" data-label="Email">
              <span>
                {{element.dental_supplier?.email}}
                {{element.dental_practice?.email}}
                {{element.dental_professional?.email}}
              </span>
            </td>
          </ng-container>
          <!-- Phone No -->
          <ng-container matColumnDef="phone">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Phone No </th>
            <td mat-cell *matCellDef="let element" data-label="Phone No">
              <span>
                {{element.dental_supplier?.phone}}
                {{element.dental_practice?.phone}}
                {{element.dental_professional?.phone}}
              </span>
            </td>
          </ng-container>
          <!-- Action Column -->
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef>
              <span class="tab_head"> Action </span>
            </th>
            <td mat-cell *matCellDef="let element" data-label="action" (click)="$event.stopPropagation()"
              (click)="$event.stopPropagation()" style="pointer-events:all;" data-label="Action">
              <button mat-icon-button [matMenuTriggerFor]="menu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu" class="table-action-btn">
                <button type="button" class="view" mat-menu-item [routerLink]='["../enquiries", element.id]'>
                  <img src="../../../../../assets/images/icons//action_icons/view.svg" alt="img">
                  <span> View </span>
                </button>
                <!--<button type="button" class="delete" mat-menu-item (click)="delete()">
                  <img src="../../../../../assets/images/icons/action_icons/delete.svg" alt="img">
                  <span> Delete </span>
                </button>-->
                <!--<button type="button" class="edit" mat-menu-item (click)="sendReplyDialog(element)">
                  <img src="../../../../../assets/images/icons/edit.svg" alt="img">
                  <span> Send Reply </span>
                </button>-->
              </mat-menu>
            </td>
          </ng-container>
          <ng-container matColumnDef="loading">
            <th mat-footer-cell *matFooterCellDef colspan="8">
              <div class="custom-loader ">
                <div class="custom-loader custom_logo_loader">
                  <img src='../../../../../assets/images2/loader.gif' alt="img" loading="lazy" />
                </div>
              </div>
            </th>
          </ng-container>
          <ng-container matColumnDef="noData">
            <th mat-footer-cell *matFooterCellDef colspan="8" class="no-data empty-img">
              <!-- EMPTY-STATE -->
              <img src='../../../../../assets/images/empty-imgs/no_enquiries.svg' alt="img" loading="lazy" />
              <h4 class="no_state_heading">No Enquiries</h4>
            </th>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          <tr mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{ hide: dataSource != null }"></tr>
          <tr mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{hide: !( dataSource != null && dataSource.filteredData.length == 0)
      }"></tr>
        </table>
      </perfect-scrollbar>
    </div>
    <!-- TABLE-PAGINATOR -->
    <div fxLayout="column" fxLayout.lg="column" fxLayout.md="column" fxLayout.sm="column" fxLayout.xs="column"
      fxFlexFill fxLayoutGap="8px">
      <mat-paginator [length]="totalElements" [pageSize]="limit.value"></mat-paginator>
    </div>
  </section>
</div>
